import React, { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Link } from "react-router-dom";

import { CrownIcon } from "../../../assets/image/CrownIcon";
import { deleteVisit, getVisitData } from "../../../api/visitApi";
import { getReceivedLanguage } from "../../../utils/helperFunctions";
import { InitialDataItem } from "./InitialDataItem";

export function WhoVisitedProfile({profile}) {
  const getReceivedType = () => {
    return localStorage.getItem("user_type") === "provider"
        ? "Parents"
        : "Provider";
  };

  const { t, i18n } = useTranslation();
  const language = i18n.language;

  const [initialData, setInitialData] = useState([]);
  const [prevPage, setPrevPage] = useState(10);
  const [page, setPage] = useState(prevPage);
  const [received, setReceived] = useState(getReceivedType());
  const [isActive, setIsActive] = useState(false);
  const [pages, setPages] = useState(0);

  const dataShow = (page / prevPage - 1) * prevPage;
  const receivedLand = getReceivedLanguage(received, language);

  const handleDeleteVisit = async (profileSearch) => {
    try {
      const result = await getVisitData(profileSearch || received);
      setInitialData(result.data.whovisitedme);
    } catch (error) {
      console.error("Error fetching visit data:", error);
    }
  };

  const handleDeleteVisitMe = async (visitId) => {
    try {
      const result = await deleteVisit(visitId);

      handleDeleteVisit();
      setInitialData([]);
    } catch (error) {
      console.error("Error deleting visit:", error);
    }
  };

  useEffect(() => {
    handleDeleteVisit();

    window.scrollTo({ top: 200, behavior: "smooth" });
  }, [page, prevPage]);

  return (
    <>
      <div class="main-header">
        <h2 className="border">{t("Who Visited Me")}</h2>
        <div class="mail-header-bar">
          <p>
            {initialData.length} {t("profiles")}
          </p>
          <div class="btn-group flex">
            {t("text-refine")}
            <div className="select">
              <label onClick={(e) => setIsActive(!isActive)}>
                {t(receivedLand)}
                <span>
                  <img src="/images/done_a.svg" />
                </span>
              </label>
              {isActive ? (
                <ul>
                  <li
                    onClick={(e) => {
                      handleDeleteVisit("Parents");
                      setReceived(t("Parents"));
                      setIsActive(!isActive);
                    }}
                  >
                    {t("Parents")}
                  </li>
                  <li
                    onClick={(e) => {
                      handleDeleteVisit("Provider");
                      setReceived(t("Provider"));
                      setIsActive(!isActive);
                    }}
                  >
                    {t("Provider")}
                  </li>
                </ul>
              ) : (
                ""
              )}
            </div>
          </div>
        </div>
        <div class="right_side_section">
          <div class="looking_for_candidate">
            <div class="interested_fam">
              <div class="interested_fam_boxs higit">
                {initialData?.map((data, index) => {
                  if (index < page && dataShow <= index && data.service_type !== "") {
                    return (
                      <InitialDataItem
                        key={data.user_id}
                        data={data}
                        handleDeleteVisitMe={handleDeleteVisitMe}
                        received={received}
                        profile={profile}
                        language={language}
                      />
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="upgared hight2">
        <p>
          {initialData.length}
          {t("more people visited your profile. Please upgrade to")}
          <br />
          {t("view their profiles and connect.")}
        </p>
        <Link to={""}>
          <CrownIcon />
          {t("upgrade-now")}
        </Link>
      </div>
      <div className="footer_pagination pagi_post">
        <div class="btn-group">
          
          {t("result-page")}
          <select
            onChange={(e) => {
              setPrevPage(parseInt(e.target.value));
              setPage(parseInt(e.target.value));
            }}
          >
            <option value="10">10</option>
            <option value="20">20</option>
            <option value="30">30</option>
            <option value="40">40</option>
            <option value="50">50</option>
          </select>
        </div>
        <div className="pagination">
          <span className="curserpage" onClick={(e) => setPage(prevPage)}>
            {"<<"}
          </span>
          <span
            className="curserpage"
            onClick={(e) =>
              setPage(
                initialData.length > 0 && page > prevPage
                  ? page - prevPage
                  : prevPage
              )
            }
          >
            {"<"}
          </span>

          {initialData?.map((_, index) => {
            if (initialData.length > pages) {
              setPages((prevState) => prevState + prevPage);
              return (
                <span
                  onClick={(e) => setPage((index + 1) * prevPage)}
                  className={page == pages ? "active" : ""}
                >
                  {index + 1}
                </span>
              );
            }
          })}
          <span
            className="curserpage"
            onClick={(e) =>
              setPage(initialData.length > page ? page + prevPage : page)
            }
          >
            {">"}
          </span>
          <span className="curserpage" onClick={(e) => setPage(pages)}>
            {">>"}
          </span>
        </div>
      </div>
    </>
  );
}
